import { createContext, useContext, useState } from "react";

type PaymentUpdateDialogContextType = {
  isPaymentUpdateOpen: boolean;
  openPaymentUpdate: () => void;
  closePaymentUpdate: () => void;
};

const PaymentUpdateDialogContext = createContext<
  PaymentUpdateDialogContextType | undefined
>(undefined);

export function PaymentUpdateDialogProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isPaymentUpdateOpen, setIsPaymentUpdateOpen] = useState(false);

  const openPaymentUpdate = () => setIsPaymentUpdateOpen(true);
  const closePaymentUpdate = () => setIsPaymentUpdateOpen(false);

  return (
    <PaymentUpdateDialogContext.Provider
      value={{
        isPaymentUpdateOpen,
        openPaymentUpdate,
        closePaymentUpdate,
      }}
    >
      {children}
    </PaymentUpdateDialogContext.Provider>
  );
}

export function usePaymentUpdateDialog() {
  const context = useContext(PaymentUpdateDialogContext);
  if (context === undefined) {
    throw new Error(
      "usePaymentUpdateDialog must be used within a PaymentUpdateDialogProvider"
    );
  }
  return context;
}
